import { all, call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../slices/labTestSlice";

import labTestApis from "src/api/labTest";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get lab tests saga
const GetLabTestsSaga = function* GetLabTestsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.getLabTests,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getLabTestsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getLabTestsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add lab test to cart saga
const AddLabTestToCartSaga = function* AddLabTestToCartSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.addLabTestToCart,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.addLabTestToCartSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.addLabTestToCartError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get lab test cart saga
const GetLabTestCartSaga = function* GetLabTestCartSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.getLabTestCart,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getLabTestCartSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getLabTestCartError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// search lab tests saga
const SearchLabTestsSaga = function* SearchLabTestsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.searchLabTests,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.searchLabTestsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.searchLabTestsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get appointment slot saga
const GetAppointmentSlotSaga = function* GetAppointmentSlotSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.getAppointmentSlot,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getAppointmentSlotSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getAppointmentSlotSuccess(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// remove item from cart saga
const RemoveItemFromCartSaga = function* RemoveItemFromCartSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.removeItemFromCart,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.cartListDeleteSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.cartListDeleteError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// book test saga
const bookTestSaga = function* bookTestSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.bookTest,
      payload
    );
    if (response?.code === "-1") {
      // throw new Error();
      // TODO: seesion expire
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    // TODO: confirm action for code 3 : account deleted or account inactive
    yield put(actions.bookTestSuccessAction(response?.data));
    resolve(response);
  } catch (error) {
    reject(
      error instanceof Error
        ? error?.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
    );
    yield put(
      actions.bookTestErrorAction(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// confirm test saga

const confirmTestSaga = function* confirmTestSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.confirmOrder,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.confirmTestSuccessAction(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.confirmTestErrorAction(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// order summary saga

const orderSummarySaga = function* orderSummarySaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.orderSummary,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.orderSummarySuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.orderSummaryError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// reschedule lab test saga

const rescheduleLabTestSaga = function* rescheduleLabTestSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.rescheduleLabTest,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.rescheduleLabTestSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.rescheduleLabTestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// reschedule lab test saga

const cancelLabTestSaga = function* cancelLabTestSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      labTestApis.cancelLabTest,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.cancelLabTestSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.cancelLabTestError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};
export default function* labTestSaga() {
  yield all([
    takeLatest(actions.getLabTestsRequest, GetLabTestsSaga),
    takeLatest(actions.addLabTestToCartRequest, AddLabTestToCartSaga),
    takeLatest(actions.getLabTestCartRequest, GetLabTestCartSaga),
    takeLatest(actions.searchLabTestsRequest, SearchLabTestsSaga),
    takeLatest(actions.getAppointmentSlotRequest, GetAppointmentSlotSaga),
    takeLatest(actions.cartListDeleteRequest, RemoveItemFromCartSaga),
    takeLatest(actions.bookTestRequestAction, bookTestSaga),
    takeLatest(actions.confirmTestRequestAction, confirmTestSaga),
    takeLatest(actions.orderSummaryRequest, orderSummarySaga),
    takeLatest(actions.rescheduleLabTestRequest, rescheduleLabTestSaga),
    takeLatest(actions.cancelLabTestRequest, cancelLabTestSaga),
  ]);
}
